@import '~less/global-variables';

.navbar-admin {
  margin-top: @navbar-height;
  margin-bottom: 0;
  padding: 16px 0;
  border-bottom: 1px solid @gray-lighter;

  > .container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .navbar-nav {
    float: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .admin-nav-groups {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
  }

  .admin-nav-group {
    flex: 1 1 260px;
    min-width: 0;
    padding-top: 10px;
    border-top: 1px solid @gray-lighter;
  }

  .admin-nav-group__label {
    margin: 0 0 8px;
    padding: 0 12px;
    color: @gray;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    line-height: 1.5;
    text-transform: uppercase;
  }

  .navbar-nav > li > a {
    display: block;
    padding: 8px 12px;
    border-radius: 6px;
    color: @gray-dark;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    text-decoration: none;

    &:hover {
      color: darken(@brand-primary, 15%);
      background: @gray-lighter;
    }

    &:focus-visible {
      outline: 2px solid darken(@brand-primary, 10%);
      outline-offset: 2px;
    }
  }

  .navbar-nav > .active > a {
    color: darken(@brand-primary, 20%);
    background: fade(@brand-primary, 10%);
    font-weight: 600;
  }

  + .container {
    padding-top: 18px;
  }

  + .container > h2:first-child {
    margin-top: 0;
  }
}

.admin-hackerspaces-sort {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid darken(@brand-primary, 10%);
    outline-offset: 3px;
  }
}

.admin-hackerspaces-signer {
  margin: 20px 0;
  padding: 16px;
  border: 1px solid @gray-lighter;
  border-radius: 6px;

  h3 {
    margin-top: 0;
  }

  .btn {
    margin-bottom: 12px;
  }
}

.admin-hackerspaces-page code {
  overflow-wrap: anywhere;
}

@media (min-width: @screen-md-min) {
  .navbar-admin {
    position: fixed;
    top: var(--tr-header-height, @navbar-height);
    bottom: 0;
    left: 0;
    z-index: 100;
    display: block;
    width: 232px;
    margin: 0;
    padding: 16px 12px;
    overflow-y: auto;
    border: 0;
    border-right: 1px solid @gray-lighter;

    > .container {
      width: 100%;
      padding: 0;
    }

    .admin-nav-groups {
      flex-direction: column;
      flex-wrap: nowrap;
      gap: 14px;
    }

    .admin-nav-group {
      flex: 0 0 auto;
      padding: 0;
      border: 0;

      + .admin-nav-group {
        padding-top: 14px;
        border-top: 1px solid @gray-lighter;
      }
    }

    .navbar-nav {
      flex-direction: column;
      gap: 2px;
    }

    .admin-nav-group__label {
      margin-bottom: 8px;
    }

    .navbar-nav > li {
      float: none;
    }

    .navbar-nav > li > a {
      padding: 5px 12px;
    }

    + .container,
    + .container.admin-user-page {
      width: calc(100% - 264px);
      max-width: none;
      margin-right: 16px;
      margin-left: 248px;
      padding-top: calc(var(--tr-header-height, @navbar-height) + 24px);
    }
  }
}

@media (min-width: @screen-md-min) {
  body:has(.navbar-admin) #tr-footer {
    width: calc(100% - 264px);
    max-width: none;
    margin-right: 16px;
    margin-left: 248px;
  }
}

.admin-landing {
  .admin-landing__hero {
    margin-bottom: 18px;
  }

  .admin-landing__title {
    margin: 0 0 6px;
    font-size: 30px;
  }

  .admin-landing__subtitle {
    margin: 0;
    color: @text-muted;
    max-width: 62ch;
  }

  .admin-landing__search {
    margin-bottom: 20px;

    .row {
      margin-right: -8px;
      margin-left: -8px;
    }

    [class^='col-'],
    [class*=' col-'] {
      padding-right: 8px;
      padding-left: 8px;
    }

    .form-inline {
      margin-bottom: 8px;
    }
  }
}

.admin-circles-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.admin-circle-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  margin-bottom: 12px;
}

.admin-index-section {
  min-height: 240px;
  box-shadow: 0 1px 0 @gray-lighter;
}

.admin-dashboard-box {
  min-height: 220px;

  .panel-body {
    padding-bottom: 8px;
  }
}

.admin-dashboard-table {
  margin-bottom: 0;

  td {
    vertical-align: middle;
  }

  td:last-child {
    white-space: nowrap;
  }
}

.admin-negative-experience-preview {
  position: relative;
  display: inline-block;

  .admin-negative-experience-preview__trigger {
    border: 0;
    padding: 0;
    color: @link-color;
    background: transparent;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:focus-visible {
      outline: 2px solid @link-color;
      outline-offset: 2px;
    }
  }

  .admin-negative-experience-preview__popover {
    position: absolute;
    z-index: 1030;
    top: 100%;
    right: 0;
    width: 28rem;
    max-width: calc(100vw - 32px);
    max-height: 18rem;
    overflow: auto;
    padding: 12px;
    color: @text-color;
    background: #fff;
    border: 1px solid @gray-lighter;
    border-radius: 4px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
    text-align: left;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-weight: normal;
  }
}

.admin-index-links {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;

  li {
    margin-bottom: 0;
    border-top: 1px solid @gray-lighter;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.admin-index-link {
  a {
    display: block;
    padding: 10px 0;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: none;
      opacity: 0.95;
    }
  }

  &:first-child {
    border-top: none;
  }
}

.admin-index-link-title {
  display: block;
  font-weight: 700;
}

.admin-index-link-description {
  display: block;
  margin-top: 4px;
  color: @text-muted;
}

.admin-search-users__actions {
  max-width: 30%;
}

.admin-acquisition-stories-page {
  h2 {
    margin-top: 0;
  }
}

.admin-audit-log-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  .form-control {
    width: auto;
    max-width: 100%;
  }

  label {
    margin-bottom: 0;
  }
}

.admin-audit-log-summary {
  max-width: 32em;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-audit-log-table details {
  min-width: 7em;
  summary {
    cursor: pointer;
  }
  pre {
    max-width: 32em;
  }
}

.admin-acquisition-stories-table {
  // A slight fade without lowering opacity on controls or focus indicators.
  .admin-acquisition-stories-contacted {
    &,
    > td {
      color: #474747;
    }

    a {
      color: #98612a;
    }

    .text-muted {
      color: #707070;
    }
  }

  th:first-child,
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(6),
  td:first-child,
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(6) {
    width: 1%;
    white-space: nowrap;
  }
}

.admin-acquisition-stories-header-help {
  border-bottom: 1px dotted currentColor;
  cursor: help;
}

.admin-acquisition-stories-member {
  display: flex;
  align-items: center;

  .avatar {
    margin-right: 8px;
  }
}

.admin-acquisition-stories-sort {
  padding: 0;
  color: inherit;
  font-weight: inherit;
}

.admin-action,
.admin-label,
.zendesk-inbox-search {
  margin: 2px 5px;
}

.admin-hidden-until-hover {
  opacity: 0;
}

td:hover .admin-hidden-until-hover {
  opacity: 1;
}

.admin-user-state {
  display: flex;
  flex-wrap: wrap;
}

.admin-copy-text {
  user-select: all;
}

.admin-user-page__search {
  margin-bottom: 24px;

  h2 {
    margin-top: 0;
    margin-bottom: 16px;
  }
}

.admin-user-search-form {
  .form-control {
    max-width: 520px;
    width: 100%;
  }
}

.admin-user-loading {
  margin-top: 8px;
  margin-bottom: 0;
}

.admin-user-report-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 14px;

  h3 {
    margin: 0;
  }
}

.admin-user-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px 24px;
  padding: 16px;
  background: #fff;
  border: 1px solid @gray-lighter;
  border-radius: 8px;

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    margin: 0;
    padding: 8px 12px;
    border: 1px solid darken(@gray-lighter, 8%);
    border-radius: 6px;
    background: #fff;
    color: @gray-dark;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-decoration: none;
    box-shadow: none;

    &:hover:not(:disabled) {
      background: @body-bg;
      border-color: @gray-light;
      color: @gray-darker;
    }

    &:focus-visible {
      outline: 2px solid darken(@brand-primary, 10%);
      outline-offset: 2px;
    }

    &:disabled {
      color: @gray;
      background: @gray-lighter;
      border-color: @gray-lighter;
      opacity: 0.65;
      cursor: not-allowed;
    }
  }

  .btn-danger {
    color: darken(@brand-danger, 15%);
    background: fade(@brand-danger, 5%);
    border-color: fade(@brand-danger, 30%);

    &:hover:not(:disabled) {
      color: darken(@brand-danger, 20%);
      background: fade(@brand-danger, 12%);
      border-color: @brand-danger;
    }
  }
}

.admin-user-action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.admin-user-action-label {
  flex-basis: 100%;
  color: @gray;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.admin-user-roles {
  .panel-body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    padding: 0;
  }

  .admin-user-action-label {
    flex-basis: auto;
  }

  .list-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    padding: 0;
  }

  li > a,
  li > span:not(.sr-only) {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border: 1px solid darken(@gray-lighter, 5%);
    border-radius: 20px;
    background: #fff;
    color: @gray-dark;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    text-decoration: none;

    &:focus-visible {
      outline: 2px solid darken(@brand-primary, 10%);
      outline-offset: 2px;
    }
  }

  li > a:hover {
    color: darken(@brand-primary, 20%);
    background: fade(@brand-primary, 8%);
    border-color: fade(@brand-primary, 40%);
  }
}

.admin-user-embedded-profile {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid @gray-lighter;

  .profile-view-embedded {
    margin-top: 20px;
  }
}

.admin-user-page h4 {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.admin-section-raw-data {
  margin-left: auto;
  font-size: 14px;
  font-weight: normal;
  text-align: right;

  summary {
    color: @link-color;
    cursor: pointer;
  }

  pre {
    max-width: 720px;
    margin-top: 8px;
    text-align: left;
    white-space: pre-wrap;
  }
}

.admin-readable-table {
  margin-bottom: 10px;

  th {
    width: 140px;
    color: @text-muted;
    font-weight: 600;
  }
}

.admin-readable-item {
  padding: 0 0 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid @gray-lighter;

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
  }

  .btn {
    margin-right: 5px;
  }
}

.admin-user .admin-user-state {
  margin-bottom: 20px;
  .admin-label {
    font-size: 100%;
    &:first-child {
      margin-left: 0;
    }
  }
}

.admin-notes .tr-editor {
  min-height: 100px;
  margin: 5px 0;
  padding: 10px;
  &,
  &:focus {
    border: 1px solid @gray-lighter;
  }
}

.admin-note {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid @gray-lighter;
}

.support-inbox {
  padding-bottom: 40px;
  overflow-wrap: anywhere;

  h1 {
    margin: 0 0 8px;
    font-size: 32px;
  }

  h2 {
    margin: 0 0 18px;
    font-size: 22px;
  }

  h3 {
    margin: 0 0 8px;
    font-size: 17px;
  }

  label {
    margin-bottom: 6px;
    color: @text-color;
  }

  .btn-default {
    border-color: @gray-lighter;
  }

  .btn:focus-visible,
  a:focus-visible,
  .support-inbox__queue-item:focus-visible {
    outline: 2px solid @brand-primary;
    outline-offset: 3px;
  }
}

.support-inbox__intro {
  margin-bottom: 24px;

  p {
    margin: 0;
    color: @text-muted;
  }
}

.support-inbox__layout {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 2fr);
  gap: 24px;
  align-items: start;
}

.support-inbox__sidebar,
.support-inbox__detail {
  min-width: 0;
}

.support-inbox__card {
  padding: 24px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid @gray-lighter;
  border-radius: 6px;
}

.support-inbox__filters {
  display: grid;
  gap: 16px;
  margin-bottom: 20px;
}

.support-inbox__list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;

  li + li {
    margin-top: 8px;
  }
}

.support-inbox__queue-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 14px;
  border: 1px solid @gray-lighter;
  border-radius: 4px;
  background: #fff;
  color: @text-color;
  text-align: left;
  overflow-wrap: anywhere;

  &:hover {
    background: #f5faf8;
  }

  &[aria-pressed='true'] {
    border-color: @brand-primary;
    background: #eef8f5;
    box-shadow: inset 3px 0 @brand-primary;
  }
}

.support-inbox__queue-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: @text-muted;
}

.support-inbox__pager,
.support-inbox__views {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.support-inbox__pager .btn {
  padding: 6px 12px;
  font-size: 14px;
}

.support-inbox__search {
  h2 {
    font-size: 18px;
  }

  form {
    display: grid;
    gap: 10px;
  }

  label {
    margin: 0;
  }

  .btn {
    justify-self: start;
  }

  ul:empty {
    display: none;
  }

  ul {
    padding-left: 20px;
    margin-top: 16px;
  }
}

.support-inbox__request-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;

  h2 {
    margin: 0;
    font-size: 26px;
  }
}

.support-inbox__eyebrow {
  margin: 0 0 6px;
  font-size: 13px;
  color: @text-muted;
}

.support-inbox__status {
  display: inline-block;
  flex-shrink: 0;
  padding: 4px 9px;
  border-radius: 4px;
  background: #f0f1f2;
  color: #555;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;

  &[data-status='open'] {
    background: #e4f5ee;
    color: #24634c;
  }

  &[data-status='new'],
  &[data-status='pending'] {
    background: #fff3d8;
    color: #78540b;
  }

  &[data-status='hold'] {
    background: #e8eef8;
    color: #36527b;
  }

  &[data-status='solved'],
  &[data-status='closed'] {
    background: #edf0f2;
    color: #545b62;
  }
}

.support-inbox__metadata {
  display: grid;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 14px;

  > div {
    display: grid;
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 12px;
  }

  dt {
    color: @text-muted;
    font-weight: normal;
  }

  dd {
    margin: 0;
  }
}

.support-inbox__message {
  padding: 18px;
  margin-bottom: 18px;
  border-left: 3px solid @gray-lighter;
  background: #f8f9fa;
  white-space: pre-wrap;
}

.support-inbox__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;

  p {
    flex: 1 1 220px;
    margin: 0;
    font-size: 13px;
    color: @text-muted;
  }

  label {
    margin: 0;
  }
}

.support-inbox__status-select {
  width: auto;
  min-width: 150px;
}

.support-inbox__counts {
  margin: 0 0 12px;
  font-size: 13px;
  color: @text-muted;
}

.support-inbox__status-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0;
  margin: 0 0 16px;
  list-style: none;

  button {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 4px 8px;
    border: 1px solid @gray-lighter;
    border-radius: 4px;
    font-size: 12px;
    color: inherit;
    background: transparent;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      border-color: @gray;
      text-decoration: underline;
    }

    &[aria-pressed='true'] {
      border-color: @gray;
      background: @gray-lighter;
    }
  }
}

.support-inbox__conversation {
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid @gray-lighter;
}

.support-inbox__conversation-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;

  h3 {
    margin: 0 0 5px;
    font-size: 21px;
  }

  p {
    margin: 0;
    color: @text-muted;
    font-size: 13px;
  }
}

.support-inbox__attachment-note {
  align-self: flex-start;
  padding: 8px 10px;
  border-radius: 4px;
  background: #f5f6f7;
}

.support-inbox__messages {
  display: grid;
  gap: 12px;
  padding: 0;
  margin: 0 0 20px;
  list-style: none;
}

.support-inbox__message-item {
  padding: 16px;
  border: 1px solid @gray-lighter;
  border-left: 3px solid #9aa2a9;
  border-radius: 4px;
  background: #fff;

  &[data-direction='outbound'] {
    border-left-color: @brand-primary;
    background: #f5faf8;
  }

  > header,
  > footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
  }

  > header {
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 13px;
  }

  time,
  > footer {
    color: @text-muted;
    font-size: 12px;
  }

  > footer {
    padding-top: 10px;
    margin-top: 12px;
    border-top: 1px solid @gray-lighter;
  }
}

.support-inbox__message-body {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.support-inbox__quoted-message {
  margin-top: 10px;

  summary {
    color: @text-muted;
    cursor: pointer;
    font-size: 13px;
  }

  .support-inbox__message-body {
    padding: 10px 12px;
    margin-top: 8px;
    border-left: 2px solid @gray-lighter;
    background: #f8f9fa;
  }
}

.support-inbox__delivery {
  font-weight: 600;
}

.support-inbox__attachments,
.support-inbox__truncation-note {
  padding: 10px 12px;
  margin-top: 12px;
  background: #f5f6f7;
  font-size: 13px;

  ul {
    margin: 6px 0;
  }

  p {
    margin: 0;
    color: @text-muted;
  }
}

.support-inbox__conversation-pager {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.support-inbox__composer {
  display: grid;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid @gray-lighter;

  .btn {
    justify-self: start;
  }
}

.support-inbox__composer-note {
  margin: 0;
  color: @text-muted;
  font-size: 13px;
}

.support-inbox__members {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  padding: 20px 0;
  margin-bottom: 16px;
  border-top: 1px solid @gray-lighter;
  border-bottom: 1px solid @gray-lighter;

  p {
    margin-bottom: 8px;
  }

  a {
    font-size: 13px;
  }
}

.support-inbox__hint {
  font-size: 13px;
  color: @text-muted;
  margin-bottom: 16px;
}

.support-inbox__views .btn[aria-pressed='true'] {
  background: #eef8f5;
  border-color: @brand-primary;
  color: #24634c;
}

.support-inbox__investigation {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid @gray-lighter;

  h3 {
    font-size: 20px;
    margin-bottom: 16px;
  }

  article {
    font-size: 14px;
  }
}

.support-inbox__empty,
.support-inbox__empty-detail {
  color: @text-muted;
}

.support-inbox__empty {
  padding: 16px 0;
}

.support-inbox__empty-detail {
  padding: 40px 24px;
  text-align: center;

  p {
    margin: 0;
  }
}

@media (max-width: 767px) {
  .support-inbox__layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .support-inbox__card {
    padding: 18px;
  }

  .support-inbox__members {
    grid-template-columns: minmax(0, 1fr);
  }
}

.admin-member-stats {
  border-radius: 8px;

  .panel-body {
    padding: 16px;
  }

  .admin-user-state:empty {
    display: none;
  }
}

.admin-member-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 599px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.admin-member-stat {
  padding: 16px;
  border: 1px solid @gray-lighter;
  border-radius: 6px;
  background: @body-bg;

  h5 {
    margin: 0 0 12px;
    color: @gray;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 16px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
    line-height: 1.5;
  }

  a {
    text-decoration: underline;
    text-underline-offset: 3px;

    &:focus-visible {
      outline: 2px solid darken(@brand-primary, 10%);
      outline-offset: 2px;
    }
  }
}

.admin-member-stat-total {
  margin: 0 0 10px;
  color: @gray-dark;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.4;
  font-variant-numeric: tabular-nums;

  a {
    color: inherit;
  }
}

.admin-member-stat-note {
  margin: 12px 0 0;
  color: @gray;
  font-size: 12px;
  line-height: 1.5;
}

.admin-member-email-status:not(:empty) {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid @gray-lighter;
}

// Member reports use the available desktop width; public profiles stay contained.
@media (min-width: 1200px) {
  .container.admin-user-page {
    width: 100%;
    max-width: none;
    padding-right: 24px;
    padding-left: 24px;
  }
}

.admin-user-page {
  padding-bottom: 20px;

  .admin-user-report-header {
    gap: 10px;
    margin-bottom: 10px;

    h3 {
      font-size: 22px;
    }
  }

  .admin-user-actions {
    gap: 12px 20px;
    padding: 12px;

    .btn {
      min-height: 34px;
      padding: 6px 10px;
      font-size: 13px;
    }
  }

  .admin-user-roles {
    margin-bottom: 14px;
  }
}

.admin-member-report-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.admin-member-box {
  min-width: 0;
  border: 1px solid @gray-lighter;
  border-radius: 8px;
  background: #fff;

  > h4 {
    margin: 0;
    padding: 10px 14px;
    border-bottom: 1px solid @gray-lighter;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.5;

    > a {
      color: @gray-dark;
    }
  }

  > .panel {
    margin: 0;
    border: 0;
    border-radius: 0 0 8px 8px;
    box-shadow: none;

    > .panel-body {
      padding: 12px 14px;
      overflow-wrap: anywhere;
    }
  }

  .admin-readable-table {
    table-layout: fixed;
    margin-bottom: 0;
  }

  .table:last-child,
  .panel-body > p:last-child {
    margin-bottom: 0;
  }
}

.admin-member-box--wide {
  grid-column: ~'1 / -1';
}

.admin-member-stats-grid {
  gap: 10px;

  @media (min-width: 1440px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

.admin-member-stat {
  padding: 12px;

  h5 {
    margin-bottom: 8px;
  }
  ul {
    gap: 4px 12px;
  }
}

.admin-member-stat-total {
  font-size: 20px;
}
.admin-member-stats .admin-user-state .admin-label {
  font-size: 12px;
}

.admin-user-page .admin-user-embedded-profile {
  margin-top: 0;
  padding: 14px;
  border: 1px solid @gray-lighter;
  border-radius: 8px;
  background: #fff;

  > h4 {
    margin-top: 0;
    font-size: 15px;
    font-weight: 600;
  }
}

.admin-circles-table {
  min-width: 460px;
  background: #fff;

  > thead > tr > th,
  > tbody > tr > td {
    vertical-align: middle;
    text-align: left;
  }

  th button {
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    font-weight: 600;
    text-align: inherit;
  }

  th:last-child,
  td:last-child {
    text-align: right;
    white-space: nowrap;
  }

  td:nth-child(2) {
    overflow-wrap: anywhere;
  }

  .admin-circles-table__name {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;

    > span:last-child {
      min-width: 90px;
      overflow-wrap: anywhere;
    }
  }

  img,
  .admin-circles-table__placeholder {
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    object-fit: cover;
  }

  .admin-circles-table__placeholder {
    background: @gray-lighter;
  }

  .admin-circles-table__hidden {
    display: block;
    font-size: 12px;
  }

  button:focus-visible {
    outline: 2px solid darken(@brand-primary, 10%);
    outline-offset: 3px;
  }

  .admin-circles-table__name:hover {
    color: darken(@brand-primary, 15%);
  }
}

.admin-threads-table {
  th,
  td {
    vertical-align: middle;
  }
  time {
    white-space: nowrap;
  }
  ul {
    margin: 0;
  }
}
